import React, { Component } from "react";
import {SubsidiaryUtils} from "../../../../../../../utils/Subsidiary/SubsidiaryUtils";
import { Subsidiary } from "../../../../../types/subsidiaries";
import { hallsStoreSelectors } from "../../../../../store/store";
import { connect } from "react-redux";
import { Components } from "@webtech/webtech-ui-react/build/webtech-ui";

export interface MarketFilterProps {
    subsidiaryList: Subsidiary[];
    filter: string[];
    onFilterMarket: (markets) => void;
}

class MarketFilter extends Component<MarketFilterProps, {}> {
    selectMenu: React.RefObject<Components.SelectMenu>;

    constructor(props) {
        super(props);
        this.selectMenu = React.createRef();
    }

    clearFilter = () => {
        this.selectMenu.current.selectItem([]);
        this.selectMenu.current.setDisplayString("Choose Subsidiary");
    };

    render() {
        return (
            <Components.SelectMenu
                key={`${this.props.filter}`}
                ref={this.selectMenu}
                noValueLabel="Choose Subsidiary"
                multipleSelection
                items={
                    this.props.subsidiaryList &&
                    this.props.subsidiaryList.length > 0
                        ? SubsidiaryUtils.subsidiarySelectItems(this.props.subsidiaryList)
                        : []
                }
                onChange={this.props.onFilterMarket}
                value={this.props.filter}
            />
        );
    }
}

const mapStateToProps = state => ({
    subsidiaryList: hallsStoreSelectors.subsidiaryList(state)
    //filter: hallsStoreSelectors.filteredMarkets(state)
});

export default connect(mapStateToProps, null, null, { forwardRef: true })(
    MarketFilter
);
